<template>
  <div id="extra-component-form-validation-demo">

    <p class="mb-4"><a href="#" rel="nofollow">Menu Configuration</a> Page to config the Menu that used in the system
    </p>

    <List></List>
  </div>
</template>

<script>

import List from "./MenusList.vue"

export default {
  components: {
    List
  }
}
</script>
